import * as typesPlans from "./types/plans";
import API from "../api";

export const getPlans = () => async (dispatch: any) => {
  try {
    dispatch({
      type: typesPlans.GET_PLANS_LOADING,
      payload: {
        loading: true
      }
    });
    const listPlans = await API.get(`/plan`);
    return dispatch({
      type: typesPlans.GET_PLANS_SUCCESS,
      payload: {
        plans: listPlans.data,
        loading: false,
        success: true
      }
    });
  } catch (e) {
    return dispatch({
      type: typesPlans.GET_PLANS_FAILED,
      payload: {
        loading: false,
        success: false
      }
    });
  }
};

export const getPlansComparative = planIds => async (dispatch: any) => {
  try {
    dispatch({
      type: typesPlans.GET_PLANS_COMPARATIVE_LOADING,
      payload: {
        loading: true
      }
    });
    const listPlans = await API.get(`/plan/comparative?planIds=${planIds}`);
    return dispatch({
      type: typesPlans.GET_PLANS_COMPARATIVE_SUCCESS,
      payload: {
        plansComparative: listPlans.data,
        loading: false,
        success: true
      }
    });
  } catch (e) {
    return dispatch({
      type: typesPlans.GET_PLANS_COMPARATIVE_FAILED,
      payload: {
        loading: false,
        success: false
      }
    });
  }
};
